<div #mainContainer class="ticker-main-container">
	<div #scrollableContainer class="ticker-scrollable-container" >
		<div *ngFor="let viewEvent of viewEvents" class="icon" (click)="logEvent(viewEvent)">
			<ng-container [ngSwitch]="viewEvent.ev">
				<ng-container *ngSwitchCase="'xst'">
					<img *ngIf="viewEvent.et === 'Creative'" src="/resources/img/realtime/ticker/Ad.svg" alt="" />
					<img *ngIf="viewEvent.et !== 'Creative'" src="/resources/img/realtime/ticker/New.svg" alt="" />
				</ng-container>
				<img *ngSwitchCase="'add'" src="/resources/img/realtime/ticker/New.svg" alt="" />
				<img *ngSwitchCase="'xcl'" src="/resources/img/realtime/ticker/Interaction.svg" alt="" />
				<img *ngSwitchCase="'pa'" src="/resources/img/realtime/ticker/Pause.svg" alt="" />
				<img *ngSwitchCase="'st'" src="/resources/img/realtime/ticker/Play.svg" alt="" />
				<img *ngSwitchCase="'rs'" src="/resources/img/realtime/ticker/Play.svg" alt="" />
				<img *ngSwitchCase="'rp'" src="/resources/img/realtime/ticker/Replay.svg" alt="" />
				<img *ngSwitchCase="'se'" src="/resources/img/realtime/ticker/SkipForward.svg" alt="" />
				<img *ngSwitchCase="'fn'" src="/resources/img/realtime/ticker/Completed.svg" alt="" />
				<div *ngSwitchCase="'time'" class="ticker-time" >
					{{ viewEvent.time | date:'HH:mm' }}
				</div>
				<div *ngSwitchCase="'spacer'" class="spacer" ></div>
			</ng-container>
			
		</div>
	</div>
	<div class="ticker-blue-line"></div>
</div>
